import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatTableModule } from "@angular/material/table";
import { NgbPopoverModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { NgxMaskDirective, provideNgxMask, NgxMaskPipe } from "ngx-mask";
import { LandAreaDialogComponent } from "./land-area-dialog/land-area-dialog.component";
import { LandAreasComponent } from "./land-areas.component";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,

    TranslateModule.forChild(),
    NgbPopoverModule,
    NgxMaskDirective,
    NgxMaskPipe,

    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatDialogModule,
    MatButtonModule
  ],
  declarations: [
    LandAreasComponent,
    LandAreaDialogComponent
  ],
  exports: [
    LandAreasComponent
  ],
  providers: [
    provideNgxMask()
  ]
})
export class LandAreasModule {}